module.exports = __webpack_public_path__ + "img/logo-zalopay.58776ba8.svg";